/* TODO: t() */
import React, { Component } from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';

import renderElementMenuItem, {
  formElementTypes,
} from '../FormBuilder/FormElements/helpers/renderElementMenuItem';
import { FormElementType } from '../../types/shared/FormFieldDefinition';
import { Modal } from '../uiold';

type Props = {
  onCancel: () => void;
  onSelect: (type: FormElementType) => void;
};

type State = {
  isVisible: boolean;
};

class FormFieldDialog extends Component<Props, State> {
  state: State = {
    isVisible: true,
  };

  render() {
    return (
      <Modal
        isVisible={this.state.isVisible}
        title="Add Form Field"
        onClose={this._hideDialog}
      >
        <Modal.Body>{this._renderAddFieldMenuItems()}</Modal.Body>
      </Modal>
    );
  }

  _renderAddFieldMenuItems = (): React.ReactNode => {
    return formElementTypes.map((type) => {
      let menuItem = renderElementMenuItem(type);
      if (menuItem != null) {
        return (
          <TouchableOpacity
            key={type}
            onPress={() => this._onFieldPress(type)}
            style={styles.item}
          >
            {menuItem}
          </TouchableOpacity>
        );
      }
      return null;
    });
  };

  _hideDialog = () => {
    this.props.onCancel();
  };

  _onFieldPress = (type: FormElementType) => {
    this.props.onSelect(type);
  };
}

let styles = StyleSheet.create({
  item: {
    paddingVertical: 4,
  },
});

export default FormFieldDialog;
